import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Frame({ size = 48, tint = 'rgb(73, 192, 248)', children, ...rest }) {
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", width: size, height: size, fill: "none", role: "img", ...rest, children: [_jsx("circle", { cx: "32", cy: "32", r: "30", fill: tint, opacity: "0.18" }), _jsx("g", { stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round", children: children })] }));
}
// 1. Wand — Harry Potter, magic, fantasy
export function IllusWand(p) {
    return (_jsxs(Frame, { tint: "rgb(206, 130, 255)", ...p, children: [_jsx("path", { d: "M15 49l26-26" }), _jsx("path", { d: "M41 23l3-3m-3-3l3 3m3 0l-3-3" }), _jsx("circle", { cx: "46", cy: "20", r: "2", fill: "currentColor" }), _jsx("path", { d: "M13 53l4-4" })] }));
}
// 2. Shield — Avengers, heroes, justice
export function IllusShield(p) {
    return (_jsxs(Frame, { tint: "rgb(238, 85, 85)", ...p, children: [_jsx("path", { d: "M32 12l16 6v14c0 10-7 17-16 20-9-3-16-10-16-20V18l16-6z" }), _jsx("circle", { cx: "32", cy: "30", r: "5" })] }));
}
// 3. Ring — LOTR, bonds, adventure
export function IllusRing(p) {
    return (_jsxs(Frame, { tint: "rgb(250, 169, 25)", ...p, children: [_jsx("circle", { cx: "32", cy: "36", r: "16" }), _jsx("circle", { cx: "32", cy: "36", r: "11" }), _jsx("path", { d: "M24 22l4-4h8l4 4" })] }));
}
// 4. Mask — anime/Demon Slayer/hero
export function IllusMask(p) {
    return (_jsxs(Frame, { tint: "rgb(147, 211, 51)", ...p, children: [_jsx("path", { d: "M14 28c0-6 6-12 18-12s18 6 18 12v4c0 10-8 20-18 20S14 42 14 32z" }), _jsx("path", { d: "M22 30h6M36 30h6" }), _jsx("path", { d: "M26 42c3 2 9 2 12 0" })] }));
}
// 5. Film reel — movies (Pixar, etc)
export function IllusFilmReel(p) {
    return (_jsxs(Frame, { tint: "rgb(73, 192, 248)", ...p, children: [_jsx("circle", { cx: "32", cy: "32", r: "18" }), _jsx("circle", { cx: "32", cy: "32", r: "3", fill: "currentColor" }), _jsx("circle", { cx: "32", cy: "18", r: "3" }), _jsx("circle", { cx: "32", cy: "46", r: "3" }), _jsx("circle", { cx: "18", cy: "32", r: "3" }), _jsx("circle", { cx: "46", cy: "32", r: "3" })] }));
}
// 6. Lightning — energy/Matrix/Stranger Things
export function IllusLightning(p) {
    return (_jsx(Frame, { tint: "rgb(255, 199, 0)", ...p, children: _jsx("path", { d: "M34 10L20 36h10l-2 18 14-26H32z", fill: "currentColor", stroke: "none" }) }));
}
// 7. Katana — samurai / anime
export function IllusKatana(p) {
    return (_jsxs(Frame, { tint: "rgb(255, 171, 51)", ...p, children: [_jsx("path", { d: "M14 50l32-32" }), _jsx("path", { d: "M44 16l4 4-2 2-4-4z" }), _jsx("path", { d: "M16 46l-4 4" }), _jsx("circle", { cx: "44", cy: "20", r: "2" })] }));
}
// 8. Crown — royalty / The Crown / medieval
export function IllusCrown(p) {
    return (_jsxs(Frame, { tint: "rgb(250, 169, 25)", ...p, children: [_jsx("path", { d: "M10 24l6 18h32l6-18-10 6-6-12-6 12-6-12-6 12z" }), _jsx("path", { d: "M16 42h32" }), _jsx("circle", { cx: "32", cy: "14", r: "2", fill: "currentColor" })] }));
}
// 9. Spaceship — sci-fi / Star Wars / Interstellar
export function IllusSpaceship(p) {
    return (_jsxs(Frame, { tint: "rgb(63, 133, 167)", ...p, children: [_jsx("path", { d: "M18 36l14-22 14 22-14 6z" }), _jsx("circle", { cx: "32", cy: "28", r: "3" }), _jsx("path", { d: "M24 40l-4 6M40 40l4 6" })] }));
}
// 10. Coffee cup — office / daily routine
export function IllusCoffee(p) {
    return (_jsxs(Frame, { tint: "rgb(150, 90, 58)", ...p, children: [_jsx("path", { d: "M16 24h28v14c0 6-5 10-10 10h-8c-5 0-10-4-10-10V24z" }), _jsx("path", { d: "M44 28h4c2 0 4 2 4 4s-2 4-4 4h-4" }), _jsx("path", { d: "M22 14c0 3 2 3 2 6M30 14c0 3 2 3 2 6" })] }));
}
// 11. Home — family / house / Incredibles
export function IllusHome(p) {
    return (_jsxs(Frame, { tint: "rgb(255, 134, 208)", ...p, children: [_jsx("path", { d: "M12 32L32 14l20 18v16a4 4 0 01-4 4H16a4 4 0 01-4-4V32z" }), _jsx("path", { d: "M26 52V38h12v14" })] }));
}
// 12. Pizza / food — Three Broomsticks, diners
export function IllusPizza(p) {
    return (_jsxs(Frame, { tint: "rgb(255, 171, 51)", ...p, children: [_jsx("path", { d: "M10 52l22-40 22 40z" }), _jsx("circle", { cx: "28", cy: "40", r: "2", fill: "currentColor" }), _jsx("circle", { cx: "36", cy: "36", r: "2", fill: "currentColor" }), _jsx("circle", { cx: "32", cy: "46", r: "2", fill: "currentColor" })] }));
}
// 13. Airplane — travel / Indiana Jones
export function IllusPlane(p) {
    return (_jsxs(Frame, { tint: "rgb(73, 192, 248)", ...p, children: [_jsx("path", { d: "M10 40l20-2 10-14 6 2-8 16-4 10h-4l-2-8-10-2z" }), _jsx("path", { d: "M40 24l6-10" })] }));
}
// 14. Shopping bag — Breaking Bad / shop
export function IllusBag(p) {
    return (_jsxs(Frame, { tint: "rgb(147, 211, 51)", ...p, children: [_jsx("path", { d: "M14 22h36l-3 30a4 4 0 01-4 4H21a4 4 0 01-4-4z" }), _jsx("path", { d: "M22 22v-4a10 10 0 0120 0v4" })] }));
}
// 15. Brain / gears — logic / conditionals / Dark
export function IllusBrain(p) {
    return (_jsxs(Frame, { tint: "rgb(144, 105, 205)", ...p, children: [_jsx("path", { d: "M22 14c-6 0-10 6-8 12-4 2-4 8 0 10-2 6 2 12 8 12 2 2 6 2 8 0 6 0 10-6 8-12 4-2 4-8 0-10 2-6-2-12-8-12-2-2-6-2-8 0z" }), _jsx("path", { d: "M30 22v22" })] }));
}
// 16. Megaphone — speech, speaking, loud
export function IllusMegaphone(p) {
    return (_jsxs(Frame, { tint: "rgb(0, 205, 156)", ...p, children: [_jsx("path", { d: "M14 26l22-8v28l-22-8z" }), _jsx("path", { d: "M36 26h6a6 6 0 010 12h-6" }), _jsx("path", { d: "M18 38v10" })] }));
}
// 17. Open book — reading / present perfect
export function IllusBook(p) {
    return (_jsxs(Frame, { tint: "rgb(255, 199, 0)", ...p, children: [_jsx("path", { d: "M10 18l22 6 22-6v34l-22-6-22 6z" }), _jsx("path", { d: "M32 24v28" })] }));
}
// 18. Chat bubbles — reported speech / conversation
export function IllusChat(p) {
    return (_jsxs(Frame, { tint: "rgb(73, 192, 248)", ...p, children: [_jsx("path", { d: "M10 16h34v20H24l-10 8V16z" }), _jsx("path", { d: "M20 40h30v10H34l-6 6v-6H20z" })] }));
}
// 19. Compass — adventure / idioms / exploration
export function IllusCompass(p) {
    return (_jsxs(Frame, { tint: "rgb(255, 145, 83)", ...p, children: [_jsx("circle", { cx: "32", cy: "32", r: "20" }), _jsx("path", { d: "M32 18l6 14-6 14-6-14z", fill: "currentColor", stroke: "none" }), _jsx("circle", { cx: "32", cy: "32", r: "2", fill: "var(--sl-bg)" })] }));
}
// 20. Gamepad — gaming / Zelda
export function IllusGamepad(p) {
    return (_jsxs(Frame, { tint: "rgb(206, 130, 255)", ...p, children: [_jsx("path", { d: "M16 24h32a6 6 0 016 6v8a6 6 0 01-12 2l-2-4h-20l-2 4a6 6 0 01-12-2v-8a6 6 0 016-6z" }), _jsx("path", { d: "M22 32h6M25 29v6M42 30v0M42 36v0M48 33v0M36 33v0" })] }));
}
// ----- Theme mapping ------------------------------------------------------
const THEME_MAP = {
    'Harry Potter': IllusWand,
    'The Avengers': IllusShield,
    'Avengers: Endgame': IllusShield,
    'Spider-Man': IllusShield,
    'The Matrix': IllusLightning,
    'Stranger Things': IllusLightning,
    'Demon Slayer': IllusKatana,
    'Death Note': IllusBook,
    'Naruto': IllusKatana,
    'Attack on Titan': IllusShield,
    'Star Wars': IllusSpaceship,
    'Interstellar': IllusSpaceship,
    'Dune': IllusSpaceship,
    'Inception': IllusBrain,
    'Dark': IllusBrain,
    'True Detective': IllusBrain,
    'Black Mirror': IllusLightning,
    'The Lord of the Rings': IllusRing,
    'Pixar — Inside Out': IllusFilmReel,
    'The Incredibles': IllusHome,
    'Toy Story': IllusHome,
    'Studio Ghibli': IllusFilmReel,
    'Spirited Away': IllusFilmReel,
    'The Office (US)': IllusCoffee,
    'The Crown': IllusCrown,
    'Peaky Blinders': IllusCrown,
    'Breaking Bad': IllusBag,
    'Indiana Jones': IllusPlane,
    'Friends': IllusCoffee,
    'Sherlock': IllusCompass,
    'Rick and Morty': IllusBrain,
    'One Piece': IllusCompass,
    'Zelda': IllusGamepad,
};
export function pickIllustration(popCulture) {
    if (!popCulture)
        return IllusBook;
    if (THEME_MAP[popCulture])
        return THEME_MAP[popCulture];
    for (const [k, Comp] of Object.entries(THEME_MAP)) {
        if (popCulture.includes(k))
            return Comp;
    }
    return IllusBook;
}
/** Direct lookup by illustration key (used by image_select exercises). */
export const ILLUSTRATIONS_BY_KEY = {
    wand: IllusWand,
    shield: IllusShield,
    ring: IllusRing,
    mask: IllusMask,
    film: IllusFilmReel,
    lightning: IllusLightning,
    katana: IllusKatana,
    crown: IllusCrown,
    spaceship: IllusSpaceship,
    coffee: IllusCoffee,
    home: IllusHome,
    pizza: IllusPizza,
    plane: IllusPlane,
    bag: IllusBag,
    brain: IllusBrain,
    megaphone: IllusMegaphone,
    book: IllusBook,
    chat: IllusChat,
    compass: IllusCompass,
    gamepad: IllusGamepad,
};
export function illustrationByKey(key) {
    return ILLUSTRATIONS_BY_KEY[key] ?? IllusBook;
}
//# sourceMappingURL=index.js.map